<template>
<section class="box topics display-pc">
  <div class="container">
    <com-h1 title="演讲专题"></com-h1>
    <com-topics :topics="topics"></com-topics>
  </div>
  <div class="box-button">
    <router-link to="/track"><c-button>查看所有专题及演讲</c-button></router-link>
  </div>
</section>
</template>

<script>
import ComH1 from '@/components/com-h1'
import CButton from '@/components/com-button'
import ComTopics from '@/components/com-topics'

export default {
  components: {
    ComH1,
    CButton,
    ComTopics
  },
  props: ['topics'],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<style lang="sass" scoped>
@import "../../style/variable"

.topics
  padding: 47px 0
</style>
